export const POSTS = [
    {
        slug: "ksef-fa-2-krok-po-kroku",
        title: "KSeF FA-2 krok po kroku — jak wystawić e-fakturę w 2026",
        description:
            "Praktyczny przewodnik po Krajowym Systemie e-Faktur i formacie FA-2: kogo dotyczy obowiązek, jak wystawić fakturę ustrukturyzowaną i jak nie dać się zaskoczyć w 2026.",
        date: "2026-05-12",
        category: "KSeF",
        readingTime: "7 min",
        cover: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
        body: [
            { t: "p", c: "KSeF, czyli Krajowy System e-Faktur, to centralna platforma Ministerstwa Finansów do wystawiania i odbierania faktur ustrukturyzowanych. W 2026 roku korzystanie z niego staje się obowiązkowe dla większości przedsiębiorców — również dla jednoosobowych działalności. W tym poradniku pokazujemy, jak przejść przez to bezboleśnie." },
            { t: "h2", c: "Czym jest faktura FA-2?" },
            { t: "p", c: "FA-2 to aktualny schemat (wzór) faktury ustrukturyzowanej w formacie XML. Zamiast PDF-a czy papieru, faktura jest zestawem pól danych, które KSeF rozumie i przechowuje. Dzięki temu urząd „widzi” fakturę w momencie jej wystawienia, a Ty masz pewność, że dokument jest zgodny z wymaganiami." },
            { t: "h2", c: "Kogo dotyczy obowiązek?" },
            { t: "ul", c: [
                "Czynnych podatników VAT — jako pierwszych.",
                "Podatników zwolnionych z VAT — w kolejnym etapie wdrożenia.",
                "Sprzedaż na rzecz konsumentów (B2C) pozostaje poza obowiązkowym KSeF.",
            ] },
            { t: "callout", c: "Wskazówka: nawet jeśli Twój etap obowiązku jest później, warto zacząć wystawiać przez KSeF wcześniej — unikniesz pośpiechu i błędów tuż przed terminem." },
            { t: "h2", c: "Jak wystawić e-fakturę krok po kroku" },
            { t: "ul", c: [
                "1. Uwierzytelnij się w KSeF (token, podpis kwalifikowany lub profil zaufany).",
                "2. Uzupełnij dane nabywcy, pozycje i stawki VAT w formacie FA-2.",
                "3. Wyślij fakturę — system nada jej numer KSeF (unikalny identyfikator).",
                "4. Numer KSeF to potwierdzenie wystawienia — zachowaj go.",
            ] },
            { t: "h2", c: "Jak Groszownik ułatwia KSeF" },
            { t: "p", c: "W Groszowniku wystawiasz fakturę jak zwykle — uzupełniasz pozycje, a aplikacja generuje poprawny FA-2 i wysyła go do KSeF w tle. Numer KSeF pojawia się automatycznie przy fakturze, a odebrane dokumenty od kontrahentów trafiają wprost do KPiR z propozycją księgowania od AI." },
            { t: "callout", c: "Groszownik jest gotowy na FA-2 już dziś — wystawiaj i odbieraj e-faktury z telefonu, bez logowania do rządowych paneli." },
            { t: "h2", c: "Najczęstsze błędy" },
            { t: "ul", c: [
                "Zła stawka VAT lub brak kodu GTU tam, gdzie jest wymagany.",
                "Literówka w NIP nabywcy — faktura zostanie odrzucona.",
                "Traktowanie PDF jako faktury KSeF — liczy się wersja ustrukturyzowana.",
            ] },
            { t: "p", c: "Podsumowując: KSeF FA-2 nie musi być stresujący. Z dobrą aplikacją to kilka tapnięć, a system pilnuje formalności za Ciebie." },
        ],
    },
    {
        slug: "zus-wakacje-2026",
        title: "ZUS Wakacje 2026 — jak legalnie nie zapłacić składek przez miesiąc",
        description:
            "Wakacje składkowe w 2026: komu przysługują, ile można zaoszczędzić, jak i kiedy złożyć wniosek. Konkretny poradnik dla JDG i freelancerów.",
        date: "2026-04-28",
        category: "ZUS",
        readingTime: "6 min",
        cover: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
        body: [
            { t: "p", c: "„Wakacje składkowe” to rozwiązanie, dzięki któremu przedsiębiorca może przez jeden miesiąc w roku nie płacić składek na ubezpieczenia społeczne — a państwo pokrywa je za niego. Dla wielu JDG to realna oszczędność rzędu kilkuset złotych. Oto jak z tego skorzystać w 2026." },
            { t: "h2", c: "Komu przysługują wakacje składkowe?" },
            { t: "ul", c: [
                "Osobom prowadzącym jednoosobową działalność gospodarczą wpisaną do CEIDG.",
                "Mikroprzedsiębiorcom (limit zatrudnienia i przychodu zgodnie z przepisami de minimis).",
                "Pod warunkiem terminowego złożenia wniosku i braku wykluczeń z pomocy publicznej.",
            ] },
            { t: "callout", c: "Wakacje składkowe obejmują składki społeczne (emerytalna, rentowa, wypadkowa, chorobowa) — składkę zdrowotną nadal płacisz." },
            { t: "h2", c: "Ile można zaoszczędzić?" },
            { t: "p", c: "Kwota zależy od podstawy, jaką deklarujesz. Dla przedsiębiorców na „małym ZUS” czy standardowej podstawie to zwykle od kilkuset złotych do ponad tysiąca w skali jednego miesiąca. Jednorazowo, ale co roku." },
            { t: "h2", c: "Jak złożyć wniosek?" },
            { t: "ul", c: [
                "1. Wniosek (RWS) składasz elektronicznie przez PUE ZUS.",
                "2. Robisz to w miesiącu poprzedzającym miesiąc zwolnienia.",
                "3. Czekasz na potwierdzenie — ZUS rozpatruje wniosek automatycznie.",
            ] },
            { t: "h2", c: "Jak Groszownik Ci pomoże" },
            { t: "p", c: "Funkcja „ZUS Wakacje 2026” w Groszowniku liczy Twoją oszczędność, przypomina o oknie na złożenie wniosku i podpowiada najlepszy miesiąc na skorzystanie z ulgi — tak, żeby nie kolidował z ważnymi płatnościami." },
            { t: "callout", c: "Ustaw przypomnienie w Groszowniku raz i nie przegap terminu — aplikacja policzy, ile realnie zyskujesz." },
            { t: "p", c: "Wakacje składkowe to jedno z niewielu rozwiązań, które po prostu dają Ci pieniądze do kieszeni. Warto z nich korzystać świadomie i co roku." },
        ],
    },
    {
        slug: "vat-oss-dla-it",
        title: "VAT-OSS dla branży IT — sprzedaż usług cyfrowych w UE",
        description:
            "Sprzedajesz usługi IT lub cyfrowe do klientów w UE? Poznaj VAT-OSS: kiedy jest obowiązkowy, jak rozliczać stawki krajów odbiorców i jak uprościć raportowanie.",
        date: "2026-04-10",
        category: "VAT-OSS",
        readingTime: "8 min",
        cover: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
        body: [
            { t: "p", c: "Jeśli jako freelancer lub firma IT sprzedajesz usługi cyfrowe konsumentom w innych krajach UE, prędzej czy później spotkasz się z VAT-OSS. To procedura, która pozwala rozliczać VAT należny w krajach odbiorców przez jedną deklarację w Polsce." },
            { t: "h2", c: "Czym jest VAT-OSS?" },
            { t: "p", c: "OSS (One Stop Shop) to uproszczony system rozliczania VAT od sprzedaży B2C w UE. Zamiast rejestrować się do VAT w każdym kraju, w którym masz klientów, składasz jedną kwartalną deklarację i płacisz VAT zbiorczo w Polsce." },
            { t: "h2", c: "Kiedy dotyczy branży IT?" },
            { t: "ul", c: [
                "Sprzedaż usług elektronicznych (SaaS, aplikacje, hosting, e-booki, kursy online) do konsumentów w UE.",
                "Po przekroczeniu wspólnego progu 10 000 EUR sprzedaży transgranicznej B2C w roku.",
                "Usługi B2B (dla firm z ważnym VAT UE) rozliczasz zwykle mechanizmem odwrotnego obciążenia — to inna ścieżka.",
            ] },
            { t: "callout", c: "Kluczowe: przy sprzedaży B2C stosujesz stawkę VAT kraju odbiorcy, a nie polską. Dla Niemiec 19%, dla Francji 20%, itd." },
            { t: "h2", c: "Jak rozliczać VAT-OSS krok po kroku" },
            { t: "ul", c: [
                "1. Zarejestruj się do procedury OSS (formularz VIU-R).",
                "2. Przy każdej sprzedaży B2C ustal kraj konsumenta i właściwą stawkę.",
                "3. Co kwartał złóż deklarację VIU-DO i zapłać zbiorczy VAT.",
                "4. Przechowuj ewidencję sprzedaży OSS przez 10 lat.",
            ] },
            { t: "h2", c: "Jak Groszownik upraszcza VAT-OSS" },
            { t: "p", c: "Groszownik automatycznie rozpoznaje sprzedaż transgraniczną, przypisuje właściwą stawkę VAT kraju odbiorcy i pilnuje progu 10 000 EUR. Gdy zbliża się termin, przygotowuje dane do deklaracji VIU-DO — bez ręcznego liczenia w arkuszach." },
            { t: "callout", c: "Sprzedajesz kursy albo SaaS w UE? Włącz VAT-OSS w Groszowniku i miej stawki oraz limity pod kontrolą." },
            { t: "p", c: "VAT-OSS brzmi groźnie, ale w praktyce to jedna deklaracja i trochę pilnowania stawek. Z automatyzacją staje się niemal niewidoczny." },
        ],
    },
];

export const getPost = (slug) => POSTS.find((p) => p.slug === slug);
